import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import usePageType from 'helpers/usePageType';
import Navigation from 'components/Navigation';
import useTheme from 'helpers/useTheme';
import StyledWrap, { StyledVirtualBg, MainContent } from './styled';

const PageLayout: FC<{ children: JSX.Element }> = ({ children }) => {
  const {
    isOnboardingWelcome,
    isOnboardingSuccess,
    isOnboardingProfileCompletion,
    isOnboardingListDetail,
    isArchive,
    isSavedPicks,
    isDiscovery,
  } = usePageType();
  const { pathname } = useLocation();

  const isDark = useTheme();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  const hideNavigation =
    isOnboardingWelcome ||
    isOnboardingSuccess ||
    isOnboardingProfileCompletion ||
    isOnboardingListDetail ||
    isArchive ||
    isSavedPicks;

  return (
    <StyledWrap isDark={isDark}>
      {!hideNavigation && <Navigation />}
      <StyledVirtualBg isDark={isDark} isDiscovery={isDiscovery} />
      <MainContent isSavedPicks={isSavedPicks} isDiscovery={isDiscovery}>
        {children}
      </MainContent>
    </StyledWrap>
  );
};

export default PageLayout;
